import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const PauseIcon = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, stroke, strokeOpacity, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg ref={ref} {...props} viewBox="0 0 24 24">
          <path d="M4 22V2H10V22H4Z" fill="currentcolor" />
          <path d="M14 22V2H20V22H14Z" fill="currentcolor" />
          <path
            d="M3.5 22V22.5H4H10H10.5V22V2V1.5H10H4H3.5V2V22ZM13.5 22V22.5H14H20H20.5V22V2V1.5H20H14H13.5V2V22Z"
            stroke={stroke}
            strokeOpacity={strokeOpacity}
          />
        </svg>
      </Icon>
    );
  },
);

PauseIcon.displayName = "PauseIcon";
